import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import { chartThemeColorsDonut } from "./index";

const tooltipFunc = ({ series,dataPointIndex,},formatData) => {
  let selected = series && series[0][dataPointIndex];
  const {name, total_discount} = formatData.bar[dataPointIndex];

  return (
    `<div style="color:white;background-color:${chartThemeColorsDonut[dataPointIndex]};padding: 0.2rem;"> Name: ` +
      name +
    `<div className='donut-text'> Dis: ${
      Number(total_discount).toFixed(3)
    }</div>` +
    `Usage: ${selected}` +
    "</div>"
  );
};

const parseData = (data) => {
  if (data && (data.length || Object.keys(data)?.length))
    return {
      bar: Array.isArray(data) ? data : [],
      total: data?.total ? data.total : [],
    };
  return {
    bar: [],
    total: [],
  };
};

const CustomVerticalBar = ({ data, heading, size, handleReq = null, url=null, loading=false }) => {
  
  const [formatData, setFormatData] = useState({
    bar: null,
    total: [],
  });
  
  useEffect(() => {
    if(data){
      setFormatData(parseData(data));
    }else{
      setFormatData({
        bar: null,
        total: [],
      })
    }
      
  }, [data]);
    
  return (
    <div className={`col row mx-0 mt-3 ${size} px-2 position-relative`}>
    <div className="row px-0 mx-0 justify-content-between col col-12 ">
      <div className="dashboard__card col col-12 w-100 flex-basis-100">
        {heading ? <h5 style={{fontSize: "1.05rem"}} className="mb-1 mt-0">{heading}</h5> : ""}
        <div className="d-flex flex-col mx-3 my-2" style={{ gap: "3rem" }}>
          {formatData.total?.length > 0 && formatData.total.map((total) => (
            <div>
              <p className="mb-0 font-weight-bold">
                {total.formated_value ? total.formated_value : total.value}
              </p>
              <p className="mb-0" style={{ fontSize: "0.75rem" }}>
                {total.name}
              </p>
            </div>
          ))}
        </div>
        {
         formatData.bar ? (
            <Chart
              width="100%"
              height= "260px"
              type="bar"
              series={[
                {
                  name: heading,
                  data: formatData.bar.map((data) => parseFloat(data.total_usage)),
                },
              ]}
              options={{
                chart: {
                  type: "bar",
                },
                plotOptions: {
                  bar: {
                    //vertical: true,
                    distributed: true,
                    borderRadius: 2,
                  },
                },
                colors: chartThemeColorsDonut,
                dataLabels: {
                  enabled: false,
                },
                tooltip: {
                  enabled: true,
                  x: {
                    show: true
                  },
                  custom: (p) => tooltipFunc(p,formatData),
                },
                // tooltip: {
                //   enabled: true,
                //   x: {
                //     show: true
                //   },
                //   y: {
                //     enabled: true,
                //     formatter: function(value){
                //       return value.toFixed(2);
                //     }
                //   }
                // },
                xaxis: {
                  categories: formatData.bar.map((data) => data.name),
                  labels: {
                    show:false
                  },
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return value;
                    },
                    style:{
                      fontSize:"10px"
                    }
                  },
                 
                  tickAmount: 5,
                },
                
                legend: {
                  show: true,
                  fontSize:"10px",
                  position: "bottom",
              
                }
              }}
            />
            ): (
              <div className="btn_load">
                {
                  loading ? (
                    <>
                      {/*loading */}
                      <CustomSpinLoader loading={loading}/>
                    </>
                  ) : (
                    <button className="btn btn-sm btn-primary rounded-md" onClick={()=>url && handleReq(url)}>Load Data</button>
                  )
                }
              </div>
           )
         }
      </div>
    </div>
  </div>
  )
}

export default CustomVerticalBar
